import React, { Component } from 'react';
import ValidationSection from './validation_section';
import ValidationError from './validation_error';
import I18n from '~/utils/translations';

class Input extends Component {
  render() {
    const { errors, className, optional, hint, inputAddon, inputRef, prepend, ...others } = this.props;
    return (
      <ValidationSection className={`input-container ${className}`} errors={errors}>
        <label>
          <div className="input-text-container">
            {this.props.label}
            {this.hint && <span className="input-hint">{this.hint}</span>}
          </div>
          <div className="input-field-wrapper">
            {inputAddon}
            {prepend && <span className="prepend">{prepend}</span>}

            <input ref={this.setRef} className="input" {...others} />
          </div>

          <ValidationError version="2" errors={errors} />
        </label>
      </ValidationSection>
    );
  }

  setRef = (input) => {
    this.root = input;
    if (this.props.inputRef) {
      this.props.inputRef(input);
    }
  };

  get hint() {
    if (!!this.props.hint) {
      return this.props.hint;
    }
    if (this.props.optional) {
      return I18n.t('optional_input');
    }
    return null;
  }
}

export default Input;
